import { PLAYER_HAND, DEALER_HAND, COMMUNITY_HAND, } from './strings';

export const INITIAL_STATE = {
  [PLAYER_HAND]: { cards: [], },
  [DEALER_HAND]: { cards: [], },
  [COMMUNITY_HAND]: { cards: [], },
};
